import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

import { DecimalNumber, SubmissionScore } from '@module/assignment';
import styled from '@xstyled/styled-components';
import { Space, Col, Row, Tooltip } from 'antd';
import { SingleSelectInput, styleVariables } from '@lib/common';
import { GradingAnswer } from './base-answer.component';
import { ScoreInputNumber } from '../score-input';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
var StyledSpace = styled(Space)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n"])));
var StyledCorrectAnswerText = styled.label(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-weight: ", ";\n  min-width: 80px;\n  flex-shrink: 0;\n  text-align: left;\n"])), function (props) {
  return props.$error ? props.theme.color.fontColorError : props.theme.color.fontColorSuccess;
}, styleVariables.font.fontWeightStrong);
var StyledRow = styled(Row)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex: 1;\n"])));
var StyledSubQuestion = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n"])));
var StyledAnswerRow = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n"])));
var StyledScoreInputContainer = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  flex-shrink: 0;\n"])));
export var GradingMatching = function GradingMatching(_ref) {
  var question = _ref.question,
      label = _ref.label,
      answerGroup = _ref.answerGroup,
      disabled = _ref.disabled,
      updatedAnswerId = _ref.updatedAnswerId,
      isOnGradingProcess = _ref.isOnGradingProcess,
      onGradeAnswer = _ref.onGradeAnswer;
  var isAllSubQuestionNotGraded = answerGroup.answers.every(function (answeredSubQuestion) {
    return !answeredSubQuestion.hasGraded();
  });
  var totalScore = isAllSubQuestionNotGraded ? null : answerGroup.answers.reduce(function (sum, answer) {
    if (!answer.hasGraded()) {
      return sum;
    }

    return DecimalNumber.roundNumber(sum + answer.score);
  }, 0);

  var getSavedAnswer = function getSavedAnswer(subQ) {
    var _answerGroup$answers, _answerGroup$answers$;

    var savedAnswer = answerGroup === null || answerGroup === void 0 ? void 0 : (_answerGroup$answers = answerGroup.answers) === null || _answerGroup$answers === void 0 ? void 0 : (_answerGroup$answers$ = _answerGroup$answers.find(function (a) {
      return a.subQuestionId === subQ.id.toString();
    }).value) === null || _answerGroup$answers$ === void 0 ? void 0 : _answerGroup$answers$.answerId;
    return savedAnswer;
  };

  var renderAnswers = function renderAnswers() {
    return question.subQuestions.map(function (subQ, index) {
      var _question$answers$fin, _question$answers;

      var answeredSubQuestion = answerGroup.answers.find(function (a) {
        return a.subQuestionId === subQ.id.toString();
      });
      var correctAnswer = question.correctAnswers.find(function (a) {
        return a.subQuestionId === subQ.id.toString();
      });
      var correctAnswerDescription = (_question$answers$fin = question.answers.find(function (a) {
        return a.id.toString() === (correctAnswer === null || correctAnswer === void 0 ? void 0 : correctAnswer.answerId);
      })) === null || _question$answers$fin === void 0 ? void 0 : _question$answers$fin.description;
      return /*#__PURE__*/_jsxs(StyledSubQuestion, {
        children: [/*#__PURE__*/_jsxs(StyledAnswerRow, {
          children: [/*#__PURE__*/_jsxs(StyledRow, {
            children: [/*#__PURE__*/_jsx(Col, {
              span: 10,
              children: /*#__PURE__*/_jsxs(Space, {
                size: 'large',
                children: [/*#__PURE__*/_jsxs("div", {
                  children: ["(", index + question.index, ")"]
                }), /*#__PURE__*/_jsx("div", {
                  children: subQ.description
                })]
              })
            }), /*#__PURE__*/_jsx(Col, {
              span: 8,
              children: /*#__PURE__*/_jsx(SingleSelectInput, {
                defaultValue: [getSavedAnswer(subQ)],
                disabled: true,
                options: ((_question$answers = question.answers) === null || _question$answers === void 0 ? void 0 : _question$answers.length) > 0 && question.answers.map(function (a) {
                  return {
                    value: a.id.toString(),
                    label: a.description
                  };
                })
              })
            })]
          }), /*#__PURE__*/_jsxs(StyledCorrectAnswerText, {
            $error: correctAnswer.score !== answeredSubQuestion.score,
            children: ["(", correctAnswer.score === answeredSubQuestion.score ? label.correct : label.incorrect, ")"]
          }), correctAnswer !== null && correctAnswer !== void 0 && correctAnswer.score ? /*#__PURE__*/_jsx(Tooltip, {
            title: disabled ? label.disabledScoreInputText : '',
            children: /*#__PURE__*/_jsx(StyledScoreInputContainer, {
              children: /*#__PURE__*/_jsx(ScoreInputNumber, {
                label: {
                  score: label.score
                },
                min: 0,
                max: correctAnswer === null || correctAnswer === void 0 ? void 0 : correctAnswer.score,
                score: (answeredSubQuestion === null || answeredSubQuestion === void 0 ? void 0 : answeredSubQuestion.score) !== SubmissionScore["default"].value ? answeredSubQuestion === null || answeredSubQuestion === void 0 ? void 0 : answeredSubQuestion.score : null,
                onGradedScore: function onGradedScore(score) {
                  return onGradeAnswer === null || onGradeAnswer === void 0 ? void 0 : onGradeAnswer(score, answeredSubQuestion.id.toString());
                },
                disabled: updatedAnswerId === answeredSubQuestion.id.toString() || disabled || isOnGradingProcess
              })
            })
          }) : null]
        }), !(answeredSubQuestion !== null && answeredSubQuestion !== void 0 && answeredSubQuestion.score) && (answeredSubQuestion === null || answeredSubQuestion === void 0 ? void 0 : answeredSubQuestion.score) === 0 && correctAnswerDescription && /*#__PURE__*/_jsx(Row, {
          children: /*#__PURE__*/_jsx(Col, {
            span: 12,
            children: /*#__PURE__*/_jsxs(StyledCorrectAnswerText, {
              children: ["(", label.correctAnswer, ": ", correctAnswerDescription, ")"]
            })
          })
        })]
      }, subQ.id.toString());
    });
  };

  return /*#__PURE__*/_jsx(GradingAnswer, {
    question: question,
    label: label,
    disabled: true,
    score: totalScore,
    children: /*#__PURE__*/_jsx(StyledSpace, {
      direction: "vertical",
      size: "middle",
      children: renderAnswers()
    })
  });
};